import React, { Component } from 'react'
import {
    Row,
    Col,
    Button,
    Table,
    Checkbox,
    Popconfirm,
    message,
    Select,
    Pagination,
    Modal,
    Spin,
    Tooltip,
    Radio,
    Badge
} from 'antd'
import { api, app, config } from "../../app"
import utils from "../../utils"
import _ from "underscore"
import common from "./common"
import ReviewSearch from "../../components/ReviewSearch"
import ReviewFailModal from "../../components/ReviewFailModal"

const Option = Select.Option

function checkBtn (item) {
    const obj = {
        text: "参加并支付",
        disabled: false,
    }
    if (item.pay_status === "1") {
        obj.disabled = true
        obj.text = "已报名"
    } else if (item.pay_status === "2") {
        obj.disabled = true
        obj.text = "已退款"
    } else if (item.allly_status === 1) {
        obj.disabled = true
        obj.text = "已结束报名"
    } else if (parseInt(item.join_number) >= parseInt(item.train_number)) {
        obj.disabled = true
        obj.text = "名额已满"
    } else if (parseInt(item.train_price) === 0) {
        obj.text = "报名参加"
    }
    return obj
}

class ReHonorWall extends Component {
    constructor (props) {
        super(props)
        this.state = {
            review_visible: false,
            reviewInfo: {},
            data_loading: true,
            selectedRowKeys: [],
            auditList: [],
            levelList: [],
            typeList: [],
            total: 0,
            page: 1,
            dataType: '1',
            type_id: '0',
            search_type: 'searchform_honorname',
            search_val: '',
            train_info: {},
            loading: true,
            train_modal: false,
            train_modal_loading: false,
            sel_level: ''
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.levelSource(true)
        // await this.typeSource()
        await this.dataSource()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data)

    /**
     * 数据加载
     * @returns {Promise<void>}
     */
    dataSource = async (page = 1) => {
        await this.setData({ page, auditList: [], data_loading: true })
        let { dataType, search_type, search_val, sel_level } = this.state, params = {
            page,
            search_val,
            search_type,
            level: sel_level,
            is_audit: dataType,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg, count } = await app.post(api.HAdminAuditLists, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            await this.setData({
                selectedRowKeys: [],
                data_loading: false,
                auditList: utils.addArrayKey(data),
                total: parseInt(count || 0),
            })
        }
    }

    /**
     * 省份列表数据
     */
    levelSource = async (init) => {
        let { flag, data, msg } = await app.post(api.HAdminAuditTitle, { indexno: app.getData('indexno') })
        if (flag === 1) {
            const state = { levelList: data }
            if (init) {
                state.sel_level = data[0].level
                state.loading = false
            }
            await this.setData(state)
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 类目类型数据
     */
    typeSource = async () => {
        await this.setData({ type_loading: true })
        let { flag, data, msg } = await app.post(api.HSelectTypeLists)
        if (flag === 1) {
            await this.setData({ typeList: data, type_loading: false })
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 审核结果
     * @returns {Promise<void>}
     */
    handleCheckReview = async (audit, detail, reviewInfo) => {
        app.alert('正在审核~', 'loading', '35%', 0)
        const { uri, id, id_key, source } = reviewInfo || this.state.reviewInfo
        let params = {
            audit_flag: audit,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        params[id_key] = id //id
        if (audit === 0) params.message = detail
        const { flag, msg } = await app.post(uri, params)
        message.destroy()
        if (audit === 0) this.CloseReviewModal()
        if (flag === 1) {
            app.alert('审核成功', 'success')
            if (source) source()
            await this.levelSource(false)
        } else {
            app.alert(msg, 'warn')
        }
    }

    /**
     * 批量审核
     * @param type
     */
    handlePLReview = async (type) => {
        let { selectedRowKeys, auditList, page, total } = this.state, len = selectedRowKeys.length
        if (len === 0) {
            app.alert('请选择审核内容', 'warn')
            return
        }
        let tp = parseInt((total - len) / 20)
        tp = (total - len) % 20 === 0 ? tp : tp + 1
        if (tp >= page) {
            tp = page
        }
        let id = selectedRowKeys.map(index => auditList[index - 1].id).join(',')
        let reviewInfo = {
            id,
            uri: api.HAdminAudit,
            id_key: "id",
            source: () => this.dataSource(tp),
        }
        if (type === 1) {
            await this.handleCheckReview(1, "", reviewInfo)
        } else if (type === 0) {
            this.OpenReviewModal(reviewInfo)
        }
    }

    /**
     * 搜索
     * @param search_type
     * @param search_val
     */
    handleSearch = async (search_type, search_val) => {
        await this.setData({ search_type, search_val })
        await this.dataSource()
    }

    /**
     * 全选
     * @param e
     * @returns {Promise<void>}
     */
    handleAllSel = async (e) => {
        let checked = e.target.checked
        let selectedRowKeys = []
        if (checked) {
            selectedRowKeys = _.range(1, this.state.auditList.length + 1)
        }
        await this.setData({ selectedRowKeys })
    }

    /**
     * 打开不通过审核对话框
     * @param uri
     * @param id_key
     * @param source
     * @param id
     * @constructor
     */
    OpenReviewModal = (reviewInfo) => {
        this.setData({ review_visible: true, reviewInfo })
    }

    /**
     * 关闭不通过审核对话框
     * @constructor
     */
    CloseReviewModal = () => {
        this.setData({ review_visible: false, reviewInfo: {} })

    }

    /**
     * 审核原因验证
     * @param rule
     * @param value
     * @param callback
     */
    handleReviewResult = (rule, value, callback) => {
        if (value && value.trim() === '') {
            callback('请输入审核失败原因！')
        }
        callback()
    }

    /**
     * 关闭培训对话框
     */
    handleCloseTrainModal = () => {
        this.setData({ train_modal: false, train_info: {} })
    }

    /**
     * 打开培训对话框
     * @param id
     */
    handleOpenTrainModal = async (id) => {
        await this.setData({ train_modal: true, train_modal_loading: true })
        const params = {
            id,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg } = await app.post(api.TraintDetailsNew, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = {}
        }
        await this.setData({ train_info: data, train_modal_loading: false })
    }

    /**
     * Tab按钮变换
     * @param e
     */
    handleTabBtnChange = async (e) => {
        const { value } = e.target
        await this.setData({ sel_level: value, dataType: '1' })
        // , type_id: this.state.typeList[0].id
        if (this.rs_ref) {
            this.rs_ref.handleSelectChange('searchform_honorname')
        }
        await this.dataSource()
    }

    render () {
        let {
            data_loading, auditList, selectedRowKeys, total, page, dataType, review_visible, levelList,
            sel_level, loading
        } = this.state
        if (loading) {
            return (
                <div style={{ textAlign: 'center', padding: '3rem 0' }}>
                    <Spin size="large" tip="正在加载..."/>
                </div>
            )
        }
        let tp = parseInt((total - 1) / 20)
        tp = (total - 1) % 20 === 0 ? tp : tp + 1
        if (tp >= page) {
            tp = page
        }
        let columns = [
                {
                    title: '姓名',
                    dataIndex: 'fkey_name',
                    key: 'fkey_name',
                    width: '8%'
                },
                {
                    title: '存心编号',
                    dataIndex: 'bsrno',
                    key: 'bsrno',
                    width: '8%'
                },
                {
                    title: '所属队伍',
                    dataIndex: 'teamname',
                    key: 'teamname',
                    width: '9%',
                },
                {
                    title: '荣誉名称',
                    dataIndex: 'name',
                    key: 'name',
                    width: '9%',
                },
                {
                    title: '荣誉图片',
                    dataIndex: 'img',
                    key: 'img',
                    width: '10%',
                    render: (img) => {
                        return (
                            <a href={config.imgUrl + img} target="_blank">
                                <div className="hwmt-img">
                                    <img src={config.imgUrl + img} alt="图片" style={{
                                        maxWidth: '100%',
                                        maxHeight: '120px',
                                        width: 'auto',
                                        height: 'auto',
                                    }}/>
                                </div>
                            </a>
                        )
                    }
                },
                {
                    title: '荣誉类型',
                    dataIndex: 'type_name',
                    key: 'type_name',
                    width: '8%',
                },
                {
                    title: '荣誉等级',
                    dataIndex: 'category_name',
                    key: 'category_name',
                    width: '8%',
                },
                {
                    title: '获奖日期',
                    dataIndex: 'date',
                    key: 'date',
                    width: '12%',
                },
                {
                    title: '审核状态',
                    dataIndex: 'is_audit',
                    key: 'is_audit',
                    width: '12%',
                    render: (audit, { audit_at, audit_by_name, audit_message }) => common.tableStatus(audit, audit_by_name, audit_at, audit_message)
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    key: 'remark',
                    width: '6%',
                    render: (remark) => {
                        return remark ? (
                            <Tooltip title={remark}><span
                                style={{ color: '#1890ff', cursor: 'pointer' }}>查看</span></Tooltip>
                        ) : ' - '
                    }
                },

            ],
            columns2 = [
                {
                    title: '名称',
                    dataIndex: 'fkey_name',
                    key: 'fkey_name',
                    width: '10%'
                },
                {
                    title: '荣誉名称',
                    dataIndex: 'name',
                    key: 'name',
                    width: '10%',
                },
                {
                    title: '荣誉图片',
                    dataIndex: 'img',
                    key: 'img',
                    width: '15%',
                    render: (img) => {
                        return (
                            <a href={config.imgUrl + img} target="_blank">
                                <div className="hwmt-img">
                                    <img src={config.imgUrl + img} alt="图片" style={{
                                        maxWidth: '100%',
                                        maxHeight: '120px',
                                        width: 'auto',
                                        height: 'auto',
                                    }}/>
                                </div>
                            </a>
                        )
                    }
                },
                {
                    title: '荣誉类型',
                    dataIndex: 'type_name',
                    key: 'type_name',
                    width: '10%',
                },
                {
                    title: '荣誉分类',
                    dataIndex: 'category_name',
                    key: 'category_name',
                    width: '10%',
                },
                {
                    title: '获奖日期',
                    dataIndex: 'date',
                    key: 'date',
                    width: '14%',
                },
                {
                    title: '审核状态',
                    dataIndex: 'is_audit',
                    key: 'is_audit',
                    width: '15%',
                    render: (audit, { audit_at, audit_by_name, audit_message, category_level }) => {
                        if (category_level === '3') {
                            return '无需审核'
                        }
                        return common.tableStatus(audit, audit_by_name, audit_at, audit_message)
                    }
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    key: 'remark',
                    width: '6%',
                    render: (remark) => {
                        return remark ? (
                            <Tooltip title={remark}><span
                                style={{ color: '#1890ff', cursor: 'pointer' }}>查看</span></Tooltip>
                        ) : ' - '
                    }
                },
            ],
            rowSelection = null
        if (dataType === '1') {
            let action_node = {
                title: '操作',
                dataIndex: 'id',
                key: 'id',
                width: '10%',
                render: (id) => {
                    let reviewInfo = {
                        id,
                        uri: api.HAdminAudit,
                        id_key: "id",
                        source: () => this.dataSource(tp),
                    }
                    let disabled = selectedRowKeys.length > 1
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <div>
                                <Popconfirm placement="bottom"
                                            title="确定审核通过吗？"
                                            cancelText="取消"
                                            okText="确定"
                                            onConfirm={() => this.handleCheckReview(1, "", reviewInfo)}
                                >
                                    <Button size="small" type="primary" style={{ margin: '10px 0' }}
                                            disabled={disabled}>通过</Button>
                                </Popconfirm>
                            </div>
                            <div>
                                <Button size="small" type="danger" onClick={() => this.OpenReviewModal(reviewInfo)}
                                        disabled={disabled} ghost>不通过</Button>
                            </div>
                        </div>
                    )
                }
            }
            if (sel_level === '1') {
                columns.push(action_node)
            } else {
                columns2.push(action_node)
            }
            rowSelection = {
                selectedRowKeys,
                onChange: async (selectedRowKeys) => {
                    await this.setData({ selectedRowKeys })
                }
            }
        }
        return (
            <div className="review-info">
                <div className="page-title">荣誉墙审核</div>
                <div className="page-content">
                    <div className="review-info-tab">
                        <Radio.Group value={sel_level} buttonStyle="solid" onChange={this.handleTabBtnChange}>
                            {
                                levelList.map((l, index) =>
                                    <Badge count={l.count || 0} key={index}>
                                        <Radio.Button value={l.level} className='no-select'>{l.name}</Radio.Button>
                                    </Badge>
                                )
                            }
                        </Radio.Group>
                    </div>
                    <div style={{ marginBottom: 20 }}>
                        <span>审核状态： </span>
                        <Select value={dataType} style={{ width: 120 }} onChange={async (value) => {
                            await this.setData({ dataType: value })
                            await this.dataSource()
                        }}>
                            <Option value="1">未审核</Option>
                            <Option value="2">已审核</Option>
                        </Select>
                        {/*<span style={{ marginLeft: 20 }}>荣誉类型： </span>*/}
                        {/*<Select value={type_id} style={{ width: 120, marginBottom: 20 }} onChange={async (value) => {*/}
                        {/*await this.setData({ type_id: value })*/}
                        {/*await this.dataSource()*/}
                        {/*}}>*/}
                        {/*<Option value="0">全部</Option>*/}
                        {/*{*/}
                        {/*typeList.map((m, i) => {*/}
                        {/*return (*/}
                        {/*<Option key={i} value={m.id}>{m.name}</Option>*/}
                        {/*)*/}
                        {/*})*/}
                        {/*}*/}
                        {/*</Select>*/}
                        <ReviewSearch onSearch={this.handleSearch} defaultValue="searchform_honorname" ref={(ref) => {
                            this.rs_ref = ref
                        }} type={sel_level === '1' ? 'honor-wall-user' : 'honor-wall-team'}/>
                    </div>
                    <Table columns={sel_level === '1' ? columns : columns2}
                           locale={app.tbLocale(data_loading)}
                           dataSource={auditList}
                           loading={data_loading}
                           scroll={{ y: 'calc(100% - 102px)' }}
                           style={{ height: 'calc(100% - 104px)' }}
                           rowSelection={rowSelection}
                           pagination={false}
                           footer={() => {
                               return (
                                   <Row hidden={auditList.length === 0}>
                                       <Col span={10}>
                                           <div hidden={dataType === '2'}>
                                               <Checkbox
                                                   checked={auditList.length !== 0 && auditList.length === selectedRowKeys.length}
                                                   onChange={this.handleAllSel}>全选</Checkbox>
                                               <Button disabled={!selectedRowKeys.length} style={{ margin: '0 20px' }}
                                                       type="primary"
                                                       onClick={() => this.handlePLReview(1)}>通过</Button>
                                               <Button disabled={!selectedRowKeys.length} type="danger"
                                                       onClick={() => this.handlePLReview(0)}>不通过</Button>
                                           </div>
                                       </Col>
                                       <Col span={14} style={{ textAlign: 'right' }}>
                                           <Pagination total={total} size="small" pageSize={20} current={page}
                                                       showTotal={(total) => `总数量：${total}`}
                                                       onChange={this.dataSource}/>
                                       </Col>
                                   </Row>
                               )
                           }}
                           size="small"
                    />
                </div>
                <ReviewFailModal visible={review_visible} close={this.CloseReviewModal} label="不通过原因"
                                 submit={(detail) => this.handleCheckReview(0, detail)}/>
            </div>
        )
    }
}

export default ReHonorWall



// WEBPACK FOOTER //
// ./src/routes/review/ReHonorWall.jsx